<template>
    <div class="condition-content">
        <compare-value
            ref="compare"
            input-placeholder="填写次数"
            input-unit="次"
            input-type="number"
            :value="currentValue"
            :valid="valid"
            :valid2="valid2"
            @change="onChange"
        />
    </div>
</template>

<script>
import CompareValue from './template/compare-value';
import { compareNumerRule, compareNumerText } from './formaterUtils';
import { pageValidater } from './validate';

export default {
  name: 'PagePV',

  components: {
    CompareValue,
  },

  props: {
    optionInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    value: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  data() {
    let currentValue = this.value || {};
    if (!currentValue.value && typeof currentValue.value !== 'number') {
      currentValue = {
        operand: '==',
        value: null,
      };
    }
    return {
      currentValue,
      valid: true,
      valid2: true,
    };
  },
  computed: {
    brief() {
      return `${this.optionInfo.text + compareNumerText(this.currentValue, this.$refs, '次')}`;
    },
  },

  watch: {
    value(newValue) {
      this.currentValue = newValue;
    },
  },
  mounted() {
    this.onChange(this.currentValue);
  },

  methods: {
    validate() {
      if (this.currentValue.operand === 'between') {
        const val = this.currentValue.value;
        this.valid = true;
        this.valid2 = true;
        if (!val.startValue) {
          this.valid = false;
        }
        if (!val.endValue) {
          this.valid2 = false;
        }
        if (val.startValue && val.endValue) {
          if (val.startValue > val.endValue) {
            this.valid = false;
            this.valid2 = false;
          }
        }
      } else {
        this.valid = pageValidater(this.currentValue);
      }
      return this.valid && this.valid2;
    },
    onChange(value) {
      this.valid = true;
      this.valid2 = true;
      this.currentValue = value;
      const ruleData = compareNumerRule(value, 'pagePV');
      const showVal = value;
      this.$emit('change', {
        ruleData,
        showVal,
        brief: this.brief,
        validation: pageValidater(value),
      });
    },
  },
};
</script>
